import { module } from 'modujs';
import modularLoad from 'modularload';
import shared from '../shared';
import { $body } from '../utils/dom';
import gsap from "gsap";

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const load = new modularLoad({
            enterDelay: 1500,
            transitions: {
                customTransition: {}
            }
        });

        this.DOM = {
            loading: document.querySelector('.o-loading'),
            loadingLogo: document.querySelector('.o-loading_logo'),
            loadingShape: document.querySelector('.o-loading_shape')
        };

        window.addEventListener('hide-loading', () => { this.hide(); });

        load.on('loading', (oldContainer, newContainer) => {
            this.show();
            this.call('stop', 'Scroll');
        });

        load.on('loaded', (transition, oldContainer, newContainer) => {
            shared();

            // Update body class
            this.setNewBodyClass();
            this.hide();

            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');
        });
        
    }

    show () {
        this.call('stop', 'Scroll');
        this.DOM.loading.classList.remove('-hidden');

        gsap.to(this.DOM.loadingLogo, { opacity: 1, duration: 0.2, ease: "none" });
        gsap.fromTo(this.DOM.loading,
            { clipPath: 'polygon(0 100%, 100% 100%, 100% 100%, 0 100%)' },
            { clipPath: 'polygon(0 -1%, 100% -1%, 100% 100%, 0 100%)', duration: 1, ease: "expo.inOut" }
        );
    }

    hide (delay = 0) {        
        gsap.to(this.DOM.loadingLogo, { opacity: 0, duration: 0.4, ease: "none" });
        gsap.fromTo(this.DOM.loading,
            { clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)' },
            { clipPath: 'polygon(0 0, 100% 0, 100% -1%, 0 -1%)', duration: 1, ease: "expo.inOut", onComplete: () => {
                this.DOM.loading.classList.add('-hidden');
                this.call('start', 'Scroll');
                gsap.set(this.DOM.loading, { clearProps: "all" });
            } }
        );
        
        setTimeout(() => {
            // Animate page content
            window.dispatchEvent(new Event("p-animate"));
        }, 600);
    }

    setNewBodyClass () {
        if (this.el.querySelector('[data-bodyclass]')) {
            let bodyClass = this.el.querySelector('[data-bodyclass]').getAttribute('data-bodyclass');
            $body.className = bodyClass;
        }
    }
}
